export default __webpack_public_path__ + "static/media/2.4c67c332.mp4";